import * as React from 'react';
import { twMerge } from 'tailwind-merge';

import { Calendar } from '../../../components/calendar/index';
import { Popover, PopoverContent, PopoverTrigger } from '../../../components/popover/index';
import { useFormat } from '../../../hooks/index';

type DatePickerProps = {
  className?: string;
  defaultMonth?: Date;
  fromDate?: Date;
  icon?: React.ReactNode;
  onSelect?: (state: Date | undefined) => void;
  placeholder?: string;
  toDate?: Date;
  value?: Date;
};

export const DatePicker: React.FC<DatePickerProps> = ({
  onSelect,
  fromDate,
  toDate,
  className,
  placeholder,
  icon,
  value,
  defaultMonth,
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);
  const { format } = useFormat();
  const handleDatePicked = (date: Date | undefined) => {
    onSelect?.(date);
    setIsPopoverOpen(false);
  };

  return (
    <Popover onOpenChange={setIsPopoverOpen} open={isPopoverOpen}>
      <PopoverTrigger
        className={twMerge(
          'flex h-10 w-full rounded-t-md border-b border-gray-700 bg-gray-50 p-3 pt-2',
          className,
        )}
      >
        <div className="flex flex-col items-start gap-1">
          {value && <span className="text-xs font-[450] text-gray-500">{placeholder}</span>}
          <span className="text-sm font-[450] text-gray-700">
            {value ? format(value, 'dd/MM/yyyy') : placeholder || ''}
          </span>
        </div>
        {icon}
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar
          defaultMonth={defaultMonth}
          fromDate={fromDate}
          initialFocus
          mode="single"
          onSelect={handleDatePicked}
          selected={value}
          toDate={toDate}
        />
      </PopoverContent>
    </Popover>
  );
};
